// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"96061b99","453":"c6499ba7"}[chunkId] + ".chunk.js";
};